
































import eventTracker from '@/utils/eventTracker'
import { TranslateResult } from 'vue-i18n'
import mixins from 'vue-typed-mixins'
import wrappers from '@/mixins/wrappers'
export default mixins(wrappers).extend({
  name: 'TrialComment',
  props: {
    edit: Boolean
  },
  data () {
    return {
      assessment: ''
    }
  },
  mounted () {
    this.restoreSavedAssessment()
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        save: this.offlineWrapper(this.save)
      }
    },
    savedAssessment (): string {
      return this.$store.getters['user/activities/assessment'] || ''
    },
    title (): TranslateResult {
      return this.edit
        ? this.$t('Track.Assessment.title.edit')
        : this.$t('Track.Assessment.title.add')
    },
    mode (): 'edit' | 'add' {
      return this.edit ? 'edit' : 'add'
    }
  },
  methods: {
    restoreSavedAssessment () {
      this.assessment = this.savedAssessment
      this.$nextTick(this.resizeTextArea)
    },
    trackSave () {
      eventTracker.track('Goals AddTrialSummary', {
        type: this.mode,
        choice: 'save',
        value: this.assessment
      })
    },
    trackCancel () {
      eventTracker.track('Goals AddTrialSummary', {
        type: this.mode,
        choice: 'cancel',
        value: this.assessment
      })
    },
    resizeTextArea () {
      const textArea = this.$refs.textArea as Element
      if (textArea) {
        const style = (textArea as any).style
        const borderWidth = parseInt(window.getComputedStyle(textArea).getPropertyValue('border-bottom-width'), 10)
        style.height = 'inherit'
        style.height = `${textArea.scrollHeight + borderWidth}px`
      }
    },
    async showDiscardConfirmation (
      discard: () => void,
      no: () => void
    ) {
      const { action } = await this.showModal(
        this.$t('userMessages.setAssessmentDiscardChanges.message'),
        {
          title: this.$t('userMessages.setAssessmentDiscardChanges.title'),
          buttons: [
            {
              class: 'dv-button dv-button--secondary dv-button--large',
              label: this.$t('actions.discard'),
              event: 'discard'
            },
            {
              class: 'dv-button dv-button--primary dv-button--large',
              label: this.$t('actions.no'),
              event: 'noAction'
            }
          ]
        })
      const fn = action === 'discard' ? discard : no
      fn()
    },
    cancel () {
      if (this.assessment !== this.savedAssessment) {
        this.showDiscardConfirmation(
          () => {
            // discard
            this.trackCancel()
            this.$emit('toggleCommentField', false)
          },
          () => {
            // no
          }
        )
      }
      else {
        this.$emit('toggleCommentField', false)
      }
    },
    async save () {
      await this.$store.dispatch('user/activities/SetAssessment', this.assessment)
      this.trackSave()
      this.$emit('toggleCommentField', false)
    }
  }
})
